// ui
import {
  Box,
  Alert,
  Select,
  FormControl,
  MenuItem,
  TextField,
} from "@mui/material";
import { styled } from "@mui/system";
// ★cmd-po_1206 (T4-b): frame Dialog→PoModalShell / footer→PoButton へ移行
import { PoModalShell } from "../common/PoModalShell";
import { PoButton } from "../common/PoButton";

import { LIST_POST } from "../../config/const";

const CustomTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    fontSize: "12px",
    height: "12px",
  },
});
CustomTextField.defaultProps = {
  autoComplete: "off",
};

interface FollowCallModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  callDataInf: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
    follow_call_status: number | null;
    follow_call_hope_date: string;
    follow_call_hope_time: string;
    follow_call_memo: string;
  };
  setCallDataInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
    follow_call_status: number | null;
    follow_call_hope_date: string;
    follow_call_hope_time: string;
    follow_call_memo: string;
  }) => void;
  callData: () => void;
}

const labelSx = { fontSize: 12, fontWeight: 600, color: "var(--color-sumi, #374151)", mb: 0.5 };
const reqSx = { fontSize: 10, fontWeight: 600, color: "var(--color-kohaku-text, #b45309)", ml: 0.5 };
const optSx = { fontSize: 10, color: "text.secondary", ml: 0.5 };

export function FollowCallModal(props: FollowCallModalProps) {
  const { onModal, swCloseModal, callDataInf, setCallDataInf, callData } = props;

  const submitDisabled =
    callDataInf.follow_call_status === null
      ? true
      : callDataInf.follow_call_status === 4
      ? callDataInf.follow_call_hope_date === "" || callDataInf.follow_call_hope_time === ""
      : false;

  // ★cmd-po_1206 (T4-b): 手組み sip-foot を PoModalShell の footer スロットへ status 別に分離
  const footerNode =
    callDataInf.status === "open" ? (
      <>
        <PoButton variant="secondary" onClick={swCloseModal} data-testid="follow-call-back">
          戻る
        </PoButton>
        <PoButton
          variant="primary"
          disabled={submitDisabled}
          onClick={callData}
          data-testid="follow-call-submit"
        >
          更新
        </PoButton>
      </>
    ) : callDataInf.status === "success" ? (
      <PoButton variant="primary" onClick={swCloseModal} data-testid="follow-call-success-close">
        閉じる
      </PoButton>
    ) : callDataInf.status === "failed" ? (
      <PoButton
        variant="secondary"
        onClick={() => setCallDataInf({ ...callDataInf, status: "open", message: "" })}
        data-testid="follow-call-failed-back"
      >
        戻る
      </PoButton>
    ) : undefined;

  return (
    <PoModalShell
      open={onModal}
      title="フォローコール"
      onClose={swCloseModal}
      widthPx={480}
      testidPrefix="follow-call"
      frameTestId="follow-call-modal"
      footer={footerNode}
    >
        {callDataInf.status === "open" && (
          <>
            {/* フォローコール結果 */}
            <Box>
              <Box sx={{ display: "flex", alignItems: "center", ...labelSx }}>
                フォローコール結果
                <Box component="span" sx={reqSx}>※必須</Box>
              </Box>
              <FormControl fullWidth>
                <Select
                  data-testid="follow-call-result-select"
                  value={callDataInf.follow_call_status}
                  onChange={(e) => {
                    const follow_call_status = e.target.value as number;
                    setCallDataInf({ ...callDataInf, follow_call_status });
                  }}
                  sx={{ height: "36px", fontSize: "14px" }}
                >
                  {LIST_POST.follow_call_status.map((follow_call, i) => (
                    <MenuItem
                      key={"follow_call_status" + i}
                      value={follow_call.id}
                      sx={{ fontSize: "14px", height: follow_call.value === "" ? "14px" : "24px", minHeight: "auto" }}
                    >
                      {follow_call.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            {/* dep-block: 時節のみ表示 */}
            {callDataInf.follow_call_status === 4 && (
              <Box
                sx={{
                  borderLeft: "3px solid var(--color-kohaku, #f59e0b)",
                  pl: 1.5,
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  mt: "calc(-1 * var(--sp-2, 8px))",
                }}
              >
                {/* 架電希望日 */}
                <Box>
                  <Box sx={{ display: "flex", alignItems: "center", ...labelSx }}>
                    架電希望日
                    <Box component="span" sx={reqSx}>※必須</Box>
                  </Box>
                  <CustomTextField
                    id="hope_call_date"
                    size="small"
                    type="date"
                    fullWidth
                    value={callDataInf.follow_call_hope_date}
                    onChange={(e) =>
                      setCallDataInf({ ...callDataInf, follow_call_hope_date: e.target.value })
                    }
                  />
                </Box>
                {/* 架電希望時間 */}
                <Box>
                  <Box sx={{ display: "flex", alignItems: "center", ...labelSx }}>
                    架電希望時間
                    <Box component="span" sx={reqSx}>※必須</Box>
                  </Box>
                  <CustomTextField
                    id="hope_call_time"
                    size="small"
                    fullWidth
                    value={callDataInf.follow_call_hope_time}
                    onChange={(e) =>
                      setCallDataInf({ ...callDataInf, follow_call_hope_time: e.target.value })
                    }
                  />
                </Box>
              </Box>
            )}

            {/* 備考: status=2 or 4 */}
            {(callDataInf.follow_call_status === 2 || callDataInf.follow_call_status === 4) && (
              <Box>
                <Box sx={{ display: "flex", alignItems: "center", ...labelSx }}>
                  備考
                  <Box component="span" sx={optSx}>※任意</Box>
                </Box>
                <CustomTextField
                  id="return_call_memo"
                  size="small"
                  fullWidth
                  multiline
                  rows={4}
                  value={callDataInf.follow_call_memo}
                  onChange={(e) =>
                    setCallDataInf({ ...callDataInf, follow_call_memo: e.target.value })
                  }
                />
              </Box>
            )}
          </>
        )}

        {callDataInf.status === "success" && (
          <Box sx={{ textAlign: "center", py: 3 }}>
            成功しました。
          </Box>
        )}

        {callDataInf.status === "failed" && (
          <Alert severity="error" sx={{ bgcolor: "var(--sem-error-bg, #f6d5d1)", color: "var(--sem-error, #a53229)", fontSize: 12, borderRadius: "var(--radius-md, 10px)", p: "var(--sp-3, 12px) var(--sp-4, 16px)", "& .MuiAlert-icon": { color: "var(--sem-error, #a53229)" } }}>{callDataInf.message}</Alert>
        )}
    </PoModalShell>
  );
}
